<template>
  <section class='section'>
    <div class="bar-alert" v-if="!detail.account_confirm">
      <p class="text-alert">
        El producto no se podrá aprobar hasta que el usuario {{this.detail.username}} verifique su cuenta.
      </p>
    </div>
    <modal-send-message
      v-if="modalMenssage"
      :close="showModalMessage"
      :userName="detail.username"
      :messagesUser="messageUser"
      :action="sendMessageProduct"
      :validateMessage="detail.status"
    />
    <ModalChangeStatus
      v-if="modalChangeStatus"
      :close="showModalStatus"
      :action="aceptChangeStatus"
    />
    <modal-code
      v-if="isShowModalCode"
      :close="closeModalCode"
      :action="sendCodeProduct"
    />
    <modal-oferta
      v-if="isShowModalOffer"
      :detail="detail"
      :close="closeModalOffer"
      :action="sendOfertPrice"
    />
    <modal-notification
      v-if="isShowModalReceived"
      :close="closeModalReceived"
      :action="receivedShipping"
      :detail="detail"
    />
    <modal-notification
      v-if="isShowModalPayment"
      :close="closeModalPayment"
      :action="paymentNotification"
      :detail="detail"
    />
    <modal-delete
      v-if="isShowModalDelete"
      :close="closeModalDelete"
      :action="deleteProduct"
    />
    <modal-finalize
      v-if="isShowModalFinalize"
      :close="closeModalFinalize"
      :action="finalizeProduct"
    />
    <modalPayment
      v-if="isShowModalPaymentImage"
      :close="closeModalPaymentImage"
      :action="paymentImageNotification"
      :partnerName="detail.partner ? detail.partner.name : ''"
      :deduction="partnerDeduction"
    />
    <modal-partner-deduction
      v-if="isShowModalPartnerDeduction && detail.partner"
      :close="closeModalPartnerDeduction"
      :action="savePartnerDeduction"
      :validateAction="validatePartnerDownPaymentAmount"
      :partner="detail.partner"
    />
    <ModalPaymentImage
      v-if="isShowImagePayment"
      :close="closeImagePayment"
      :propsImage="detail.image_payment"
      :propsPrice="detail.proposal_amount"
      :propsPriceReason="detail.proposal_amount_reason"
    />
    <FunnelTrackingModal
      v-if="isShowFunnelTrackingModal"
      :close="closeFunnelTrackingModal"
      :action="saveFunnelTracking"
      :detail="detail"
    />
    <nav class="level">
      <div class="level-left">
        <div class="level-item title-view">
          <h1>Detalle del producto <span v-if="detail.image_payment ? true : false" @click="showImagePayment" class="has-text-danger is-size-6" style="cursor: pointer;">Ver recibo de pago</span></h1>
          <a @click="returnView()">Regresar</a>
        </div>
        <div class="level-item" v-if="detail.saleModeId">
          <span class="tag is-medium" :class="detail.saleModeId === 2 ? 'is-success' : 'is-link'">
            {{ detail.saleModeId === 2 ? '💵' : '📦' }}&nbsp;{{ detail.saleMode }}
          </span>
        </div>
      </div>
      <div class="level-right" v-if="!detail.isDisabled">
        <template v-if="detail.is_trade_in">
          <div class="level-item">
            <router-link
              v-if="detail.tradeInUpgradeId"
              :to="'/trade-in/detalle/' + detail.tradeInUpgradeId"
              class="button is-info"
            >
              <span class="material-icons" style="margin-right: 6px; font-size: 18px;">swap_horiz</span>
              Ver Operaci&oacute;n Trade-In
            </router-link>
            <span v-else class="tag is-warning is-medium">Trade-In sin operaci&oacute;n asignada</span>
          </div>
        </template>
        <template v-else-if="detail.account_confirm">
          <div class="level-item">
          <button v-if="productStatusValue === 0" class="button is-success" @click="showModalCode">Preaprobar</button>
          <button v-if="productStatusValue === 1 || productStatusValue === 2 || productStatusValue === 3" :disabled="productStatusValue === 1 || productStatusValue === 2" class="button is-success"  @click="showModalReceived">{{'Producto recibido'}}</button>
          <!-- <button v-if="productStatusValue === 5 || productStatusValue === 6" class="button is-success" @click="showModalOffer">Envíar propuesta</button> -->
          <!-- <button v-if="productStatusValue === 7 || productStatusValue === 8" :disabled="productStatusValue === 7" class="button is-success" @click="showModalPayment">Reflejar pago en la App</button> -->
          <button v-if="productStatusValue === 4" class="button is-success" @click="showModalPaymentImage">Enviar recibo de pago</button>
          <button v-if="productStatusValue === 5" :disabled="productStatusValue === 6" @click="showModalFinalize" class="button is-success">Finalizar</button>
          <button v-if="productStatusValue === 6" class="button is-success" :disabled="loadingStatus || detail.status === 2" :class="{ 'is-loading': loadingStatus}" @click="aceptProduct(2)">Aprobar</button>
        </div>
      </template>
      <div class="level-item" v-if="detail.account_confirm">
          <button v-if="!detail.is_c2c" class="button is-info" :disabled="loadingStatus" :class="{ 'is-loading': loadingStatus }" @click="publishC2C">Publicar en tienda (C2C)</button>
          <span v-else class="tag is-info is-medium">Publicado en tienda (C2C)</span>
        </div>
      <div class="level-item">
          <button class="button is-danger is-bordered" @click="showModalDelete('delete')">Eliminar</button>
        </div>
        <!-- <div class="level-item">
          <button class="button is-warning" :disabled="loadingStatus" :class="{ 'is-loading': loadingStatus}" @click="statusRejected()">Rechazar</button>
        </div> -->
      </div>
      <div class="level-right" v-else>
        <div class="notification is-light is-flex is-align-items-center is-justify-content-space-between" style="margin-bottom: 0px;">
          <span>
            ⚠️ <strong>Proceso inactivo</strong><br>
            Este proceso fue deshabilitado por inactividad.
          </span>
          <button class="button is-danger is-light" @click="showModalDisabled = true" style="align-self: center; margin-left: 10px;">
            Habilitar
          </button>
        </div>

        <div class="modal" :class="{ 'is-active': showModalDisabled }">
          <div class="modal-background" @click="showModalDisabled = false"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">Confirmar acción</p>
              <button class="delete" aria-label="close" @click="showModalDisabled = false"></button>
            </header>
            <section class="modal-card-body">
              <p>¿Estás seguro de que deseas habilitar el proceso?</p>
            </section>
            <footer class="modal-card-foot">
              <button class="button is-success" @click="confirmEnable">Sí, habilitar</button>
              <button class="button" @click="showModalDisabled = false">Cancelar</button>
            </footer>
          </div>
        </div>
      </div>
    </nav>
    <div class="columns is-multiline is-centered">
      <div class="column is-12">
        <div class="tabs is-boxed">
          <ul>
            <li :class="{'is-active': tabActive === 'datos'}" @click="tabActive = 'datos'"><a>Datos generales</a></li>
            <li v-if="detail && detail.ventas && detail.ventas.length > 0" :class="{'is-active': tabActive === 'venta'}" @click="tabActive = 'venta'"><a>Ventas</a></li>
            <li v-if="detail.is_trade_in" :class="{'is-active': tabActive === 'trade-in'}" @click="tabActive = 'trade-in'"><a>Trade-In</a></li>
            <li :class="{'is-active': tabActive === 'diagnostico'}" @click="tabActive = 'diagnostico'"><a>Diagn&oacute;stico<TooltipStatus :complete="hasDiagnostico"/></a></li>
            <li :class="{'is-active': tabActive === 'carta'}" @click="tabActive = 'carta'"><a>Carta propiedad<TooltipStatus :complete="hasCarta"/></a></li>
            <li :class="{'is-active': tabActive === 'envio', 'is-hidden': !detail.delivery_dhl}" @click="tabActive = 'envio'"><a>Datos de env&iacute;o<TooltipStatus :complete="hasDelivery"/></a></li>
            <li :class="{'is-active': tabActive === 'recoleccion', 'is-hidden': !detail.isHomePickup}" @click="tabActive = 'recoleccion'"><a>Datos de recoleccion<TooltipStatus :complete="detail.isHomePickup"/></a></li>
            <li :class="{'is-active': tabActive === 'additional-files'}" @click="tabActive = 'additional-files'"><a>Archivos adicionales</a></li>
          </ul>
        </div>
        <!-- Se comenta para validar si no tiene implicaciones --->
        <!-- <div class="box" v-if="!loadingProduct">
          <product-detail
            v-if="!isEdit && tabActive === 'datos'"
            :detail="detail"
            :editProduct="showEditProduct"
          />
          <ventas-detail
            v-else-if="!isEdit && tabActive === 'venta'"
            :detail="detail"
            :editProduct="showEditProduct"
          />
          <product-detail-edit
            v-else
            :detail="detail"
            :updateProduct="updateProduct"
            :loading="loadingProduct"
            :productId="parseInt(productId)"
            :cancelEdit="showEditProduct"
          />
        </div> -->
      <div class="columns is-multiline is-centered">
        <div class="column is-9">
          <div class="box" v-if="!loadingProduct">
            <product-detail
            v-if="!isEdit && tabActive === 'datos'"
            :detail="detail"
            :editProduct="showEditProduct"
            :action="updateProductDetails"
          />
          <ventas-detail
            v-else-if="!isEdit && tabActive === 'venta'"
            :detail="detail"
            :editProduct="showEditProduct"
          />
          <product-detail-edit
            v-else-if="isEdit && tabActive === 'edit'"
            :detail="detail"
            :updateProduct="updateProduct"
            :loading="loadingProduct"
            :productId="parseInt(productId)"
            :cancelEdit="showEditProduct"
          />
          <diagnostico-detail
            v-else-if="!isEdit && tabActive === 'diagnostico'"
            :detail="detail"
          />
          <carta-propiedad-detail
            v-else-if="!isEdit && tabActive === 'carta'"
            :detail="detail"
          />
          <datos-envio
            v-else-if="!isEdit && tabActive === 'envio'"
            :detail="detail"
          />
          <datos-recoleccion
            v-else-if="!isEdit && tabActive === 'recoleccion'"
            :detail="detail"
          />
          <additional-files
            v-else-if="!isEdit && tabActive === 'additional-files'"
            :detail="detail"
          />
          <trade-in-tab
            v-else-if="!isEdit && tabActive === 'trade-in'"
            :upgradeId="detail.tradeInUpgradeId"
          />
          </div>
          <div class="box is-loading has-text-centered" v-else>
            <loading-component />
          </div>
        </div>
        <div class="column is-3">
          <div v-if="detail.priceOrigin" class="box price-origin-box">
            <div class="promo-row">
              <span>Origen del precio</span>
              <strong :class="detail.priceOrigin.type === 'partner' ? 'has-text-link' : ''">{{ detail.priceOrigin.label }}</strong>
            </div>
            <div class="promo-row">
              <span>RAM</span>
              <strong>{{ detail.ramGb ? `${detail.ramGb} GB` : 'Desconocida' }}</strong>
            </div>
          </div>
          <div v-if="detail.promotion_code_id && promotionCodeDetail" class="box promo-box">
            <div class="promo-head">
              <span style="font-size: 1.5rem; margin-right: 0.5rem;">🎟️</span>
              <span>¡Este producto tiene el código promocional <strong>"{{ promotionCodeDetail?.code }}"</strong>!</span>
            </div>
            <div v-if="partnerDeduction" class="promo-deduction">
              <div class="promo-row">
                <span>Enganche {{ detail.partner.name }}</span>
                <strong v-if="partnerDeduction.hasDeduction">${{ partnerDeduction.coveredAmountLabel }}{{ partnerDeduction.percentage || partnerDeduction.percentage === 0 ? ` (${partnerDeduction.percentage}%)` : '' }}</strong>
                <strong v-else-if="partnerDeduction.status === 'in_review'" class="promo-review">Por validar</strong>
                <strong v-else class="promo-pending">Pendiente</strong>
              </div>
              <div v-if="partnerDeductionOrigin" class="promo-row">
                <span>{{ partnerDeductionOrigin.label }}</span>
                <strong v-if="partnerDeductionOrigin.value">{{ partnerDeductionOrigin.value }}</strong>
              </div>
              <div v-if="partnerDeduction.hasDeduction" class="promo-row">
                <span>{{ partnerDeduction.status === 'credited' ? 'Saldo acreditado' : 'Saldo a acreditar' }}</span>
                <strong>${{ partnerDeduction.creditedAmountLabel }}</strong>
              </div>
              <div v-if="partnerDeduction.status === 'credited'" class="promo-row">
                <span>Acreditado el</span>
                <strong>{{ formatDate(partnerDeduction.creditedAt) }}</strong>
              </div>
              <button v-else class="button is-small is-fullwidth is-rounded promo-button" @click="showModalPartnerDeduction">
                {{ partnerDeductionButton }}
              </button>
            </div>
          </div>
          <template v-if="detail.status !== isSold">
            <div class="box">
              <span v-if="visible" data-tooltip="Producto Visible">👁️</span>
              <span v-else data-tooltip="Producto No Visible" style="text-decoration:line-through;filter: gray;-webkit-filter: grayscale(1);filter: grayscale(1);">👁️</span>&nbsp;
              <input
                id="switchStatus"
                type="checkbox"
                name="switchStatus"
                class="switch is-rounded is-info"
                :checked="visible"
                @change="visibilityProduct()"
              >
              <label for="switchStatus">
                Producto visible
              </label>
            </div>
          </template>
          <div class="box">
            <p v-if="detail.is_sold && detail.sold_date">
              🛒 Producto Comprado el
              <span>{{ formatDate(detail.sold_date) }}</span>
            </p>
            <div v-else>
              <button class="button is-primary is-fullwidth"
              style="padding: 10px 15px; width: 100%; white-space: normal; word-wrap: break-word; height: auto; min-height: 50px;"
              @click="showModalSold = true">
                Marcar como vendido
              </button>
            </div>
          </div>
          <div class="modal" :class="{ 'is-active': showModalSold }">
            <div class="modal-background" @click="closeModalSold"></div>
            <div class="modal-card" style="overflow: visible;">
              <header class="modal-card-head">
                <p class="modal-card-title">Fecha de venta</p>
                <button class="delete" aria-label="close" @click="closeModalSold"></button>
              </header>
              <section class="modal-card-body">
                <v-date-picker
                  v-model="sold_date"
                />
              </section>
              <footer class="modal-card-foot">
                <button class="button is-success" @click="saveSoldDate">Guardar</button>
                <button class="button" @click="closeModalSold">Cancelar</button>
              </footer>
            </div>
          </div>

          <div class="box">
            <button
              class="button is-link is-fullwidth is-rounded funnel-button"
              @click="showFunnelTrackingModal"
              :class="{ 'is-loading': loadingProfile }"
              :disabled="loadingProfile"
            >
              <span class="icon is-small" v-if="!loadingProfile">
                <i class="material-icons" style="font-size: 18px;">filter_list</i>
              </span>
              <span class="icon is-small" v-else>
                <i class="material-icons spin" style="font-size: 18px;">autorenew</i>
              </span>
              <span>{{ loadingProfile ? 'Cargando...' : 'Seguimiento' }}</span>
            </button>
          </div>

          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="box" v-if="!loadingProfile">
                <product-user
                  :detail="detail"
                  :showModalMessage="showModalMessage"
                />
              </div>
              <div class="box is-loading has-text-centered" v-else>
                <loading-component />
              </div>
            </div>
            <!-- <div class="column is-12">
              <div class="box">
                <more-products
                  :similarProducts="detail.similarProducts"
                />
              </div>
            </div> -->
            <!-- <div class="column is-12">
              <div class="box">
                <comments-section :comments="detail.comments"/>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- <Chat v-if="detail.userId !== 4" :userId="detail.userId" :nameUser="detail.name" :username="detail.username" :userImage="detail.userImage" :chatData="chatData"/> -->
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import router from '@/router'
import gql from 'graphql-tag'
import moment from 'moment'

export default {
  name: 'DetalleDelProducto',
  components: {
    ProductDetail: () => import('@/components/Products/Detail'),
    // CommentsSection: () => import('@/components/Products/CommentsSection'),
    VentasDetail: () => import('@/components/Products/Ventas'),
    ProductDetailEdit: () => import('@/components/Products/DetailEdit'),
    ProductUser: () => import('@/components/Products/User'),
    // MoreProducts: () => import('@/components/Products/MoreProducts'),
    LoadingComponent: () => import('@/components/ui/Loading'),
    ModalSendMessage: () => import('@/components/Products/ModalSendMessage'),
    ModalChangeStatus: () => import('@/components/Products/ModalChangeStatus'),
    // Chat: () => import('@/components/Chat'),
    ModalCode: () => import('@/components/Products/ModalCode'),
    DiagnosticoDetail: () => import('@/components/Products/Diagnostico'),
    ModalOferta: () => import('@/components/Products/ModalOferta'),
    CartaPropiedadDetail: () => import('@/components/Products/CartaPropiedad'),
    ModalNotification: () => import('@/components/Products/ModalNotification'),
    ModalPaymentImage: () => import('@/components/Products/ModalPaymentImage'),
    FunnelTrackingModal: () => import('@/components/Products/FunnelTrackingModal'),
    ModalPayment: () => import('@/components/Products/ModalPayment'),
    ModalPartnerDeduction: () => import('@/components/Products/ModalPartnerDeduction'),
    DatosEnvio: () => import('@/components/Products/DatosEnvio'),
    AdditionalFiles: () => import('@/components/Products/AdditionalFiles'),
    DatosRecoleccion: () => import('@/components/Products/DatosRecoleccion'),
    ModalDelete: () => import('@/components/Products/ModalDelete'),
    ModalFinalize: () => import('@/components/Products/ModalFinalize'),
    TooltipStatus: () => import('@/components/Products/TooltipStatus'),
    TradeInTab: () => import('@/components/Products/TradeInTab')
  },
  data () {
    return {
      saleDetail: {},
      productDetails: [],
      detail: {
        similarProducts: []
      },
      tabActive: 'datos',
      productId: this.$route.params.productId,
      loadingProduct: false,
      loadingProfile: false,
      isEdit: false,
      modalMenssage: false,
      modalChangeStatus: false,
      messageUser: [],
      loadingStatus: false,
      PENDING_STATUS: 1,
      visible: false,
      is_sold: false,
      isSold: 3,
      chatData: {},
      isShowModalCode: false,
      isShowModalOffer: false,
      isShowModalReceived: false,
      isShowModalPayment: false,
      isShowModalPaymentImage: false,
      isShowModalPartnerDeduction: false,
      isShowFunnelTrackingModal: false,
      isShowImagePayment: false,
      isShowModalDelete: false,
      isShowModalFinalize: false,
      statusUpdateIsLoading: false,
      promotionCodeDetail: null,
      showModalSold: false,
      sold_date: null,
      showModalDisabled: false
    }
  },
  methods: {
    ...mapActions(['getProductDetail', 'editProduct', 'changeStatusProduct', 'sendMessage', 'deleteProductById', 'updateProductVisibility', 'publishProductC2C', 'getSaleProduct', 'getNotificationProduct', 'getChatId', 'updateProductPreapproved', 'updateProductProposal', 'changeStatusProductReceipt', 'changeStatusPaymentProduct', 'changeStatusProductPaymentImage', 'changeStatusFinalizeProduct', 'updateAditionalInformation', 'updateProductSold', 'promoCodeDetail', 'updateProductDisable', 'uploadAdminUpsertFunnelTracking', 'updatePartnerDeduction', 'validatePartnerDownPayment']),
    showEditProduct () {
      this.isEdit = !this.isEdit
      this.tabActive = !this.isEdit ? 'datos' : 'edit'
    },
    visibilityProduct () {
      this.updateProductVisibility(this.productId)
        .then(resp => {
          this.visible = !this.visible
        })
    },
    publishC2C () {
      const price = window.prompt('Precio al que se publica en la tienda (C2C). Este es el precio que paga el comprador:', this.detail.price)
      if (price === null) return
      const normalized = Number(String(price).replace(/,/g, ''))
      if (!Number.isFinite(normalized) || normalized <= 0) {
        window.alert('Ingresá un precio válido mayor a 0.')
        return
      }
      this.loadingStatus = true
      this.publishProductC2C({ productId: this.productId, price: normalized })
        .then(success => {
          this.loadingStatus = false
          if (success) {
            this.getProductDetail({ productId: this.productId })
              .then((product) => {
                this.detail = product
              })
          }
        })
    },
    isSoldProduct () {
      this.updateProductSold({ productId: this.productId, sold: this.sold, soldDate: this.sold_date })
        .then(resp => {
          this.is_sold = !this.is_sold
        })
    },
    async updateProduct (product) {
      this.loadingProduct = true
      const success = await this.editProduct({ productId: this.productId, product })
      if (success) {
        this.getProductDetail({ productId: this.productId })
          .then((product) => {
            this.detail = product
            this.loadingProduct = false
            this.showEditProduct()
          })
      }
    },
    showModalMessage () {
      this.modalMenssage = !this.modalMenssage
    },
    showModalStatus () {
      this.modalChangeStatus = !this.modalChangeStatus
    },
    statusRejected () {
      this.modalChangeStatus = true
    },
    async aceptChangeStatus (data) {
      const newData = {
        status: 5,
        rejectedMessage: data
      }
      this.changeStatus(newData)

      window.location.reload()
    },
    aceptProduct (status) {
      const newData = {
        status: status,
        rejectedMessage: ''
      }
      this.changeStatus(newData)
    },
    changeStatus (status) {
      this.loadingStatus = true
      this.changeStatusProduct({ productId: this.productId, status })
        .then(success => {
          if (success) {
            this.modalChangeStatus = false
            this.loadingStatus = false
            this.detail.status = status.status
            this.getProductDetail({ productId: this.productId })
              .then((product) => {
                this.detail = product
                this.loadingProfile = false
              })
          }
        })
    },
    statusDeleted () {
      this.deleteProductById(parseInt(this.$route.params.productId, 10))
        .then(resp => {
          router.replace({ name: 'productos' })
        })
    },
    async sendMessageProduct (message) {
      await this.sendMessage({ productId: this.productId, body: message })
      this.getProductDetail({ productId: this.productId })
    },
    returnView () {
      this.$router.go(-1)
    },
    showModalCode () {
      this.isShowModalCode = true
    },
    closeModalCode () {
      this.getProductDetail({ productId: this.productId })

      this.isShowModalCode = false
    },
    async sendCodeProduct () {
      const response = await this.updateProductPreapproved({ productId: this.productId })

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    showModalOffer () {
      this.isShowModalOffer = true
    },
    closeModalOffer () {
      this.isShowModalOffer = false
    },
    async sendOfertPrice (totalPrice) {
      const response = await this.updateProductProposal({ productId: this.productId, amount: totalPrice })

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    showModalReceived () {
      this.isShowModalReceived = true
    },
    closeModalReceived () {
      this.isShowModalReceived = false
    },
    async receivedShipping () {
      const response = await this.changeStatusProductReceipt({ productId: this.productId })

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    showModalPayment () {
      this.isShowModalPayment = true
    },
    closeModalPayment () {
      this.isShowModalPayment = false
    },
    async paymentNotification () {
      const response = await this.changeStatusPaymentProduct({ productId: this.productId })

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    showModalPartnerDeduction () {
      this.isShowModalPartnerDeduction = true
    },
    closeModalPartnerDeduction () {
      this.isShowModalPartnerDeduction = false
    },
    async savePartnerDeduction (percentage) {
      return this.applyPartnerDeduction(await this.updatePartnerDeduction({ productId: this.productId, percentage }))
    },
    async validatePartnerDownPaymentAmount (amount) {
      return this.applyPartnerDeduction(await this.validatePartnerDownPayment({ productId: this.productId, amount }))
    },
    applyPartnerDeduction (payload) {
      if (payload) {
        this.detail = {
          ...this.detail,
          partner_deduction_pct: payload.source === 'percentage' ? payload.percentage : null,
          partner: { ...this.detail.partner, deduction: payload }
        }
      }
      return payload
    },
    showModalPaymentImage () {
      this.isShowModalPaymentImage = true
    },
    closeModalPaymentImage () {
      this.isShowModalPaymentImage = false
    },
    showFunnelTrackingModal () {
      this.isShowFunnelTrackingModal = true
    },
    closeFunnelTrackingModal () {
      this.isShowFunnelTrackingModal = false
    },
    async saveFunnelTracking (data) {
      const response = await this.uploadAdminUpsertFunnelTracking({ productId: this.productId, data })

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    async paymentImageNotification (file) {
      const response = await this.changeStatusProductPaymentImage({ productId: this.productId, fileImage: file })

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    showImagePayment () {
      this.isShowImagePayment = true
    },
    closeImagePayment () {
      this.isShowImagePayment = false
    },
    showModalDelete () {
      this.isShowModalDelete = true
    },
    closeModalDelete () {
      this.isShowModalDelete = false
    },
    async deleteProduct () {
      const response = this.statusDeleted()

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    showModalFinalize () {
      this.isShowModalFinalize = true
    },
    closeModalFinalize () {
      this.isShowModalFinalize = false
    },
    async finalizeProduct () {
      const response = await this.changeStatusFinalizeProduct({ productId: this.productId })

      this.getProductDetail({ productId: this.productId })
        .then((product) => {
          this.detail = product
          this.loadingProfile = false
        })

      return response
    },
    async updateProductDetails (data) {
      this.updateAditionalInformation({ productId: this.productId, body: data })
    },
    async sendAutomaticMessage (message) {
      let response = await this.$apollo.mutate({
        mutation: gql`
          mutation ($message: String, $userId: Int) {
            addMessageAdmin(userId: $userId, message: $message) {
              id
              message
              sentByMe
              createdAt
              chatId
              image
              userId
              component
              refered {
                title
                image
                itemId
              }
            }
          }
        `,
        variables: {
          message,
          userId: this.detail.userId
        }
      })

      response = response.data.addMessageAdmin
      this.$root.$emit('automatic-message-sent', response)
    },
    closeModalSold () {
      this.showModalSold = false
      this.sold_date = null
    },
    async saveSoldDate () {
      try {
        const formattedDate = moment(this.sold_date).format('YYYY-MM-DD HH:mm:ss.SSS')

        await this.updateProductSold({
          productId: this.productId,
          sold: true,
          soldDate: formattedDate
        })
        this.is_sold = true
        this.closeModalSold()
        this.getProductDetail({ productId: this.productId })
          .then(product => {
            this.detail = product
          })
      } catch (error) {
        console.error('Error guardando fecha de venta:', error)
      }
    },
    formatDate (date) {
      if (!date) return ''
      return moment(new Date(date)).format('YYYY-MM-DD')
    },
    async confirmEnable () {
      this.showModal = false
      await this.updateProductDisable({ productId: this.productId, disableStatus: !this.detail.isDisabled })
      this.getProductDetail({ productId: this.productId })
        .then(product => {
          this.detail = product
          this.showModalDisabled = false
        })
    }
  },
  watch: {
    tabActive (newVal) {
      if (newVal === 'edit') return
      this.isEdit = false
    },
    $route (to, from) {
      this.loadingProduct = true
      this.getProductDetail({ productId: to.params.productId })
        .then((product) => {
          this.detail = product
          this.loadingProduct = false
        })
    }
  },
  async beforeMount () {
    this.loadingProduct = true
    this.loadingProfile = true
    let product = await this.getProductDetail({ productId: this.productId })
    let message = await this.getNotificationProduct({ productId: this.productId })
    if (product.statusName === 'Vendido') {
      let sale = await this.getSaleProduct(this.productId)
      product = { ...product, saleDetail: sale }
    }
    this.messageUser = message
    this.detail = product
    this.visible = product.visible
    this.is_sold = product.is_sold
    this.loadingProduct = false
    this.loadingProfile = false

    // const resp = await this.getChatId(parseInt(this.detail.userId))
    // this.chatData = resp.payload

    if (this.detail.promotion_code_id) {
      this.promotionCodeDetail = await this.promoCodeDetail(this.detail.promotion_code_id)
    }
  },
  computed: {
    partnerDeduction () {
      return this.detail.partner ? this.detail.partner.deduction : null
    },
    partnerDeductionOrigin () {
      const deduction = this.partnerDeduction
      if (deduction.submittedAmountLabel) {
        if (deduction.status === 'in_review') return { label: 'Cargado por el usuario', value: `$${deduction.submittedAmountLabel} · sin validar` }
        if (deduction.adjusted) return { label: 'Corregido por GivU', value: `el usuario puso $${deduction.submittedAmountLabel}` }
        return { label: 'Cargado por el usuario', value: 'validado por GivU' }
      }
      if (deduction.hasDeduction) return { label: 'Cargado por GivU', value: null }
      if (deduction.skipped) return { label: 'El usuario no sabe el monto', value: 'lo carga GivU' }
      if (deduction.canSubmit) return { label: 'Esperando que el usuario cargue el monto', value: null }
      return null
    },
    partnerDeductionButton () {
      if (this.partnerDeduction.status === 'in_review') return 'Validar enganche'
      return this.partnerDeduction.hasDeduction ? 'Editar enganche' : 'Cargar enganche'
    },
    productStatusValue () {
      // closed_date = finalizado
      if (this.detail.closed_date !== null) return 6
      // image_payment_date = el administrador pago el precio
      if (this.detail.image_payment_date !== null) return 5
      // date_receipt = producto recibido
      if (this.detail.date_receipt !== null) return 4
      // show_market_price_date = el usuario vio el precio del market
      if (this.detail.show_market_price_date !== null) return 3
      // diagnostic_date = el usuario mando el diagnostico
      if (this.detail.diagnostic_date !== null) return 2
      // pre_approved_date = el admin preaprobo el producto
      if (this.detail.pre_approved_date !== null) return 1
      // producto nuevo
      return 0
    },
    hasDiagnostico () {
      return this.detail.diagnostic_date !== null
    },
    hasCarta () {
      return this.detail.pdf_date !== null
    },
    hasDelivery () {
      return this.detail.dhl_delivery_id !== null
    }
  }
}
</script>

<style scoped>
  .section {
    width: 100%;
    padding: 0 20px 0 20px;
  }
  .userImage {
    width: 100px;
    height: 100px;
    background-position: 0;
    border-radius: 50%;
  }
  .calificacion {
    font-size: 12px;
  }
  .bar-alert {
    padding-top: 15px;
    padding-bottom: 15px;
    box-shadow: 0px 10px 15px -15px rgba(0, 0, 0, 0.75);
    background: #f5e355;
  }
  .text-alert {
    text-align: center;
  }
  .tabs {
    margin-bottom: 0;
  }
  .tabs .is-active a{
    color: black;
  }
  .tabs.is-boxed ul li:not(.is-active) a {
    background-color: rgba(228, 228, 228, 1);
    color: grey;
  }
  .tabs.is-boxed ul li.is-active a {
    background-color: white;
  }
  .promo-box {
    background-color: #fff8dc;
    color: #8a4d00;
  }
  .promo-head {
    display: flex;
    align-items: center;
  }
  .promo-deduction {
    margin-top: 0.85rem;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(138, 77, 0, 0.2);
  }
  .promo-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.85rem;
    padding: 0.15rem 0;
  }
  .promo-pending {
    opacity: 0.65;
    font-weight: normal;
  }
  .promo-review {
    color: #b86e00;
  }
  .price-origin-box .promo-row {
    gap: 0.5rem;
  }
  .price-origin-box strong {
    text-align: right;
  }
  .promo-button {
    margin-top: 0.7rem;
    background-color: #8a4d00;
    color: #fff8dc;
    border: none;
    white-space: normal;
    height: auto;
    min-height: 32px;
  }
</style>
